import { useState, useEffect } from 'react';
import { useAuth } from '../context/auth.context';

const useApiFetch = (initialUrl, filterRes, controlled = false, options) => {
    const [data, setData] = useState(null);
    const [axiosError, setAxiosError] = useState(null);
    const [unCaughtError, setUnCaughtError] = useState(null);
    const [loading, setLoading] = useState(controlled ? false : initialUrl ? true : false);
    const { apiClient } = useAuth();
    const [url, setUrl] = useState(initialUrl);

    const fetchData = async (url) => {
        try {
            setLoading(true);
            const response = await apiClient.get(url);
            if (filterRes) {
                const filteredData = filterRes(response.data);
                setData(filteredData);
            } else {
                setData(response.data);
            }
        } catch (error) {
            if (error.name === 'AxiosError') {
                setAxiosError(error);
            } else {
                setUnCaughtError(error);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (url) {
            if (!controlled) {
                fetchData(url);
            }
        } else {
            setData(null);
            setLoading(false);
        }
    }, [url, controlled]);

    const refetch = async (newUrl) => {
        if (newUrl) {
            await fetchData(newUrl);
            setUrl(newUrl);
        } else {
            await fetchData(url);
        }
    };
    return { data, axiosError, loading, refetch, setData };
};
export default useApiFetch;
